import React, { Component } from 'react'
import { Link, RouteComponentProps, Redirect } from 'react-router-dom'

import { client } from 'redux/redux'
import { ChildProps } from 'react-apollo'
import { InputProps } from './loginMutation'
import { WithTranslation } from 'react-i18next'
import { authenticate } from 'redux/actions/auth'
import { setCalcProject } from 'redux/actions/calcProject'
import { CALCULATION_PROJECT_QUERY } from './calculationProjectQuery'

import get from 'lodash/get'
import isNil from 'lodash/isNil'

import PageLayout from 'components/layout/pageLayout'
import Button from 'components/ui/button'
import Input from 'components/ui/input'

import loginImageRigips from 'images/login-rigips.jpg'
import loginImageAbk from 'images/login-abk.jpg'

interface LoginProps
  extends ChildProps<InputProps, Response>,
    RouteComponentProps<any>,
    WithTranslation {
  authenticated: boolean
  dispatch: any
  loginMutation: any
}

interface IErrorObject {
  [k: string]: string | null
}

type LoginState = {
  errors: IErrorObject | null
  username: string | null
  password: string | null
  stayLoggedIn: boolean
}

class Login extends Component<LoginProps, LoginState> {
  constructor(props: LoginProps) {
    super(props)
    this.state = {
      errors: null,
      username: null,
      password: null,
      stayLoggedIn: false,
    }
  }

  getValue = (key: string) => {
    return get(this.state, key)
  }

  handleLogin = () => {
    const { loginMutation, dispatch } = this.props

    const errors = {
      username: isNil(this.getValue('username')) ? 'Error Message.' : null,
      password: isNil(this.getValue('password')) ? 'Error Message.' : null,
    }

    const hasErrors = Object.values(errors).find((error) => {
      if (!isNil(error)) return true
      return false
    })

    if (hasErrors) {
      this.setState({ errors })
    } else {
      if (loginMutation) {
        loginMutation({
          variables: { username: this.state.username, password: this.state.password },
        })
          .then((res: any) => {
            // Login was successful
            if (get(res, 'data.login')) {
              this.setState({ errors: null })
              localStorage.setItem('token', `Bearer ${get(res, 'data.login').token}`)
              dispatch(authenticate(get(res, 'data.login.token')))

              /*
               * Fetch the default calculation project because it's project number is
               * needed for the getPosition query
               */
              client.query({ query: CALCULATION_PROJECT_QUERY }).then((res) => {
                dispatch(setCalcProject(get(res, 'data.getCalculationProject')))
              })
            } else {
              this.setState({
                errors: {
                  username: 'Error Message',
                  password: 'Error Message',
                },
              })
            }
          })
          .catch((err: any) => {
            this.setState({
              errors: {
                username: 'Error Message',
                password: 'Error Message',
              },
            })

            console.error(err)
          })
      }
    }
  }

  render() {
    const { authenticated, t } = this.props
    const { errors } = this.state

    if (authenticated) return <Redirect to="/projects" />

    return (
      <PageLayout pageTitle="Login">
        <div
          className="relative h-auto"
          style={{
            paddingBottom: '34.19%',
          }}
        >
          <div className="content absolute inset-0">
            <div className="absolute z-20 inset-0 flex flex-col justify-center px-48">
              <h1 className="mb-15 font-500 text-white tracking-0.23 text-20">
                {process.env.REACT_APP_ENV === 'rigips' ? t('appNameRigips') : t('appNameAbk')}
              </h1>
              <p className="whitespace-pre-wrap font-400 text-white tracking-0.1 text-15 leading-22">
                {process.env.REACT_APP_ENV === 'rigips'
                  ? t('appDescriptionRigips')
                  : t('appDescriptionAbk')}
              </p>
            </div>
            {process.env.REACT_APP_ENV === 'rigips' && (
              <div
                className="overlay absolute z-10 inset-0 h-full w-full"
                style={{
                  backgroundColor: 'rgba(7,7,7,0.35)',
                }}
              ></div>
            )}
            <img
              src={process.env.REACT_APP_ENV === 'rigips' ? loginImageRigips : loginImageAbk}
              className="absolute inset-0 h-full w-full object-cover"
              alt=""
            />
          </div>
        </div>
        {errors && (
          <div className="px-48 mt-45 font-500 text-red tracking-0.12 text-15">
            {t('userNameOrPasswordIsIncorrect')}
          </div>
        )}
        <div className="px-48 mt-45 flex">
          <div className="w-4/12">
            <Input
              name="username"
              label={t('username_email')}
              value={this.getValue('username') || ''}
              leftAlign
              error={errors && errors.username ? errors.username : undefined}
              onChange={(value) => this.setState({ username: String(value) })}
            />
          </div>
          <div className="w-4/12 ml-30">
            <Input
              type="password"
              name="password"
              label={t('password')}
              value={this.getValue('password') || ''}
              leftAlign
              error={errors && errors.password ? errors.password : undefined}
              onChange={(value) => this.setState({ password: String(value) })}
            />
          </div>
          <div className="w-4/12 ml-30 flex items-end">
            <Button className="w-full" primary onClick={this.handleLogin}>
              {t('logIn')}
            </Button>
          </div>
        </div>
        <div className="px-48 mt-25 flex">
          <div className="w-4/12">
            <Link className="link" to="/signup">
              {t('createNewAccount')}
            </Link>
          </div>
          <div className="w-4/12 ml-30">
            <Link className="link" to="/forgot-password">
              {t('forgotPassword')}
            </Link>
          </div>
          <div className="w-4/12 ml-30 flex items-end">
            {/* <CheckBox
              checked={stayLoggedIn}
              onChange={value => this.setState({ stayLoggedIn: value })}
              label={t('staySignedIn')}
            /> */}
          </div>
        </div>
      </PageLayout>
    )
  }
}

export default Login
